import React from 'react';

export default function BreadcrumbMaker(data) {

    if (window.location.pathname == "/") {
        return "";
    }


    const urlElements = window.location.pathname.replace("/docs/", "").split("/");

    let concat = "/docs";
    let anotherVar = [];

    for (let i = 0 ; i < urlElements.length ; i++) {
        concat += "/" + urlElements[i];
        anotherVar.push(concat);
    }
    document.title = data.data[concat] + " | Syncloop Docs";

    return (
        <div className="brd_title">
            {anotherVar.map((item, index) => (
                <a href="javascript:void(0)">{data.data[item] + ((urlElements.length - 1 == index) ? '' : ' / ')} </a>

            ))}
        </div>
    );

}
